import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=3d0dbf2e&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=ts&setup=true"
export * from "./Integrations.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=3d0dbf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0dbf2e",
  null
  
)

export default component.exports